import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';
import { colors } from '@shared/theme/colours';

import { styles } from './KatoLogoShortInverse.styles';

interface KatoLogoShortInverseIconProps extends WithStyles<typeof styles> {
  color?: string;
  onClick?: () => void;
}

const KatoLogoShortInverseIconComponent: FC<KatoLogoShortInverseIconProps> = ({
  classes,
  color = colors.kato.salmon[500],
  onClick,
}) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      classes={{ root: classes.root }}
      onClick={onClick}
    >
      <rect width="32" height="32" rx="6" fill={color} />
      <path d="M20.9409 16.0006L24.5654 6L14.6193 11.8059V20.1942L24.5654 26L20.9409 16.0006Z" fill="white" />
      <path d="M14.6193 6.57416H7.43469V16.0006L14.6193 11.8059V6.57416Z" fill="white" />
      <path d="M7.43469 25.426H14.6193V20.1942L7.43469 16.0006V25.426Z" fill="white" />
    </SvgIcon>
  );
};

export const KatoLogoShortInverseIcon = withStyles(styles)(KatoLogoShortInverseIconComponent);
